import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { motion } from "framer-motion";
import { LEAD_TYPES } from "../services/leadEmail";
import { submitLegacyLead } from "../services/legacyLeadSubmission";

function Kuga4990campaign() {
  const navigate = useNavigate();

  const form = useForm();
  const { register, handleSubmit, formState } = form;
  const { errors } = formState;

  const marketingCampaign = async (data, slug) => {
    try {
      await submitLegacyLead({
        collectionName: slug,
        formData: data,
        firestoreData: {
          name: data.name ?? "",
          email: data.email ?? "",
          phone: data.phone ?? "",
          dealership: data.dealership ?? "",
          text: "",
          model: "KugaMarch49990",
        },
        leadPayload: {
          type: LEAD_TYPES.CAMPAIGN_OFFER,
          vehicle: {
            model: "Kuga Full Hybrid",
          },
          campaign: {
            slug,
          },
          title: "kuga4990",
          message: "Запитване за Kuga 4990 кампания",
        },
      });

      navigate("/thank-you-testdrive");
    } catch (error) {
      console.error("Грешка при запис в Firebase:", error);
    }
  };

  const renderContactForm = () => {
    const slug = "kuga-full-hybrid-march-2026-campaign";

    return (
      <form
        onSubmit={handleSubmit((data) => marketingCampaign(data, slug))}
        id="templateCampaignForm"
        className="px-8 py-16 lg:px-48"
        noValidate
      >
        <h2 className="text-xl tracking-wider text-center uppercase text-fordBlue">
          Поискай оферта
        </h2>

        {/* Име */}
        <div className="mt-8">
          <label htmlFor="name" className="text-gray-500">
            Име
          </label>
          <input
            type="text"
            id="name"
            name="name"
            {...register("name", {
              required: {
                value: true,
                message: "Моля, въведете Вашето име",
              },
            })}
          />
          <p className="text-red-500">{errors.name?.message}</p>
        </div>

        {/* Имейл */}
        <div className="mt-4">
          <label htmlFor="email" className="text-gray-500">
            Имейл
          </label>
          <input
            type="email"
            id="email"
            name="email"
            {...register("email", {
              required: {
                value: true,
                message: "Моля, въведете имейл-адрес",
              },
              pattern: {
                value: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
                message: "Невалиден имейл-адрес",
              },
            })}
          />
          <p className="text-red-500">{errors.email?.message}</p>
        </div>

        {/* Телефон */}
        <div className="mt-4">
          <label htmlFor="phone" className="text-gray-500">
            Телефон
          </label>
          <input
            type="text"
            id="phone"
            name="phone"
            {...register("phone", {
              required: {
                value: true,
                message: "Моля, въведете телефонен номер",
              },
              pattern: {
                value:
                  /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/,
                message: "Невалиден телефонен номер",
              },
            })}
          />
          <p className="text-red-500">{errors.phone?.message}</p>
        </div>

        <div className="mt-4">
          <label htmlFor="dealership" className="text-gray-500">
            Предпочитано представителство
          </label>
          <select
            name="dealership"
            id="dealership"
            {...register("dealership", {
              required: {
                value: true,
                message: "Моля, изберете представителство",
              },
            })}
          >
            <option value="" disabled>
              Моля, изберете
            </option>
            <option value="liulin2@motopfohe.bg">София Люлин</option>
            <option value="mladost@motopfohe.bg">София Младост</option>
            <option value="blagoevgrad@motopfohe.bg">Благоевград</option>
            <option value="burgas@motopfohe.bg">Бургас</option>
            <option value="varna@motopfohe.bg">Варна</option>
            <option value="velikotarnovo@motopfohe.bg">Велико Търново</option>
            <option value="gabrovo@motopfohe.bg">Габрово</option>
            <option value="dobrich@motopfohe.bg">Добрич</option>
            <option value="montana@motopfohe.bg">Монтана</option>
            <option value="pleven@motopfohe.bg">Плевен</option>
            <option value="plovdiv@motopfohe.bg">Пловдив</option>
            <option value="russe@motopfohe.bg">Русе</option>
            <option value="starazagora@motopfohe.bg">Стара Загора</option>
            <option value="smolyan@motopfohe.bg">Смолян</option>
            <option value="forsh@motopfohe.bg">Шумен</option>
          </select>
          <p className="text-red-500">{errors.dealership?.message}</p>
        </div>

        {/* Скрито поле за заглавие на кампанията */}
        <input type="hidden" name="title" value="kuga4990" />

        <button
          type="submit"
          className="px-16 py-2 mx-auto mt-8 text-white border rounded-full bg-fordBlue"
        >
          Изпрати
        </button>
      </form>
    );
  };

  return (
    <>
      {/* Video */}
      <div className="relative w-full">
        <video
          src="/images/kuga4990/mainvideo.mp4"
          autoPlay
          muted
          loop
          playsInline
          className="block w-full h-auto"
        />
        <div className="px-4 py-8 text-white bg-fordBlue lg:hidden">
          <h1 className="text-2xl font-fordBlack">НОВИЯТ FORD KUGA</h1>
          <p className="text-xl">
            Само сега с първоначален разход
            <br />
            до ключ от 4 990 лв.*
          </p>
          <button
            className="px-4 py-2 mt-4 bg-white rounded-full lg:hidden text-fordBlue"
            onClick={() => {
              const ofertaSection = document.getElementById("poiskayOferta");
              if (ofertaSection) {
                ofertaSection.scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                });
              }
            }}
          >
            Поискай оферта
          </button>
        </div>
        <motion.div
          className="absolute text-white top-[5%] left-[3%] hidden lg:block"
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1.5, ease: "easeOut" }}
        >
          <h1 className="text-6xl font-fordBlack">НОВИЯТ FORD KUGA</h1>
          <p className="text-4xl">
            Само сега с първоначален разход
            <br />
            до ключ от 4 990 лв.*
          </p>
        </motion.div>
        {/* Button */}
        <div className="absolute hidden bottom-[10%] left-1/2 -translate-x-1/2 lg:flex justify-center text-center margin-auto">
          <button
            className="px-12 pt-3 pb-2 text-2xl tracking-wide uppercase bg-white border rounded-full text-fordBlue lg:mt-auto border-fordLight hover:bg-fordBlue hover:text-white"
            onClick={() => {
              const ofertaSection = document.getElementById("poiskayOferta");
              if (ofertaSection) {
                ofertaSection.scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                });
              }
            }}
          >
            Поискай оферта
          </button>
        </div>
      </div>
      {/* 3 images */}
      <div className="flex flex-col lg:flex-row gap-4 px-4 pt-8 lg:h-[600px]">
        <div className="h-full overflow-hidden lg:w-2/3 rounded-2xl">
          <img
            src="/images/kuga4990/ford-kuga-blue-front-view.jpg"
            alt=""
            className="object-cover w-full h-full"
          />
          <div className="flex-1 p-4 mt-2 bg-gray-100 lg:hidden rounded-2xl">
            <h3 className="text-3xl tracking-wide font-fordBold text-fordBlue">
              Нова визия
            </h3>
            <p className="mt-4 hyphens-auto">
              Новият Ford Kuga впечатлява с освежен екстериорен дизайн,
              съче&shy;таващ елегантност и динамика. Подчертаната предна
              решетка, новите LED светлини и прецизно оформените аеродинамични
              линии придават силен визуален отпечатък.
            </p>
          </div>
        </div>
        <div className="flex flex-col justify-between h-full gap-4 lg:w-1/3">
          <img
            src="/images/kuga4990/lights.jpg"
            alt=""
            className="object-cover overflow-hidden rounded-2xl h-1/2"
          />
          <div className="flex-1 p-4 mt-2 bg-gray-100 lg:hidden rounded-2xl">
            <h3 className="text-3xl tracking-wide font-fordBold text-fordBlue">
              LED фарове
            </h3>
            <p className="mt-4 hyphens-auto">
              Оборудван с модерни LED предни светлини, които не само
              осигу&shy;ряват по-добра осветеност на пътя, но и придават на
              автомобила разпознаваем, запомнящ се облик.
            </p>
          </div>
          <img
            src="/images/kuga4990/wheels.jpg"
            alt=""
            className="object-cover overflow-hidden rounded-2xl h-1/2"
          />
          <div className="flex-1 p-4 mt-2 bg-gray-100 lg:hidden rounded-2xl">
            <h3 className="text-3xl tracking-wide font-fordBold text-fordBlue">
              Джанти с изразителен дизайн
            </h3>
            <p className="mt-4 hyphens-auto">
              Новите стилни джанти на Ford Kuga допринасят за още
              по-уникал&shy;ния и динамичен силует на автомобила. Създадени с
              внимание към детайла, те подчертават спортния характер и
              индивидуалност на всяка серия – Titanium, ST-Line или Active.
            </p>
          </div>
        </div>
      </div>
      {/* 3 columns text */}
      <div className="hidden gap-4 px-4 pt-4 pb-8 lg:flex">
        <div className="flex-1 p-8 bg-gray-100 rounded-2xl">
          <h3 className="text-3xl tracking-wide font-fordBold text-fordBlue">
            Нова визия
          </h3>
          <p className="mt-4 hyphens-auto">
            Новият Ford Kuga впечатлява с освежен екстериорен дизайн,
            съче&shy;таващ елегантност и динамика. Подчертаната предна решетка,
            новите LED светлини и прецизно оформените аеродинамични линии
            придават силен визуален отпечатък.
          </p>
        </div>
        <div className="flex-1 p-8 bg-gray-100 rounded-2xl">
          <h3 className="text-3xl tracking-wide font-fordBold text-fordBlue">
            LED фарове
          </h3>
          <p className="mt-4 hyphens-auto">
            Оборудван с модерни LED предни светлини, които не само
            осигу&shy;ряват по-добра осветеност на пътя, но и придават на
            автомобила разпознаваем, запомнящ се облик.
          </p>
        </div>
        <div className="flex-1 p-8 bg-gray-100 rounded-2xl">
          <h3 className="text-3xl tracking-wide font-fordBold text-fordBlue">
            Джанти с изразителен дизайн
          </h3>
          <p className="mt-4 hyphens-auto">
            Новите стилни джанти на Ford Kuga допринасят за още
            по-уникал&shy;ния и динамичен силует на автомобила. Създадени с
            внимание към детайла, те подчертават спортния характер и
            индивидуалност на всяка серия – Titanium, ST-Line или Active.
          </p>
        </div>
      </div>
      {/* Connectivity */}
      <div className="relative">
        <picture>
          <source
            media="(max-width: 768px)"
            srcSet="/images/kuga4990/ford-kuga-interior-mobile.jpg"
          />
          <img
            src="/images/kuga4990/ford-kuga-interior.jpg"
            alt=""
            className="w-full h-auto"
          />
        </picture>
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
        <div className="absolute bottom-[5%] left-[5%] text-white lg:w-1/4">
          <h3 className="text-2xl font-fordBlack">Още по-усъвършенстван.</h3>
          <p className="mt-2 text-lg font-fordRegular">
            Новият 13.2-инчов сензорен екран SYNC 4 предлага още повече
            свързаност – с безжичен Apple CarPlay или Android Auto, 5G модем и
            безжични актуализации
          </p>
        </div>
      </div>
      {/* Pulling power */}
      <div className="relative mt-8">
        <picture>
          <source
            media="(max-width: 768px)"
            srcSet="/images/kuga4990/ford-kuga-pulling-power-mobile.jpg"
          />
          <img
            src="/images/kuga4990/ford-kuga-pulling-power.jpg"
            alt="Ford Kuga pulling power"
            className="w-full h-auto"
          />
        </picture>
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 to-transparent"></div>
        <div className="absolute top-[5%] left-[3%] lg:left-[80%] lg:-translate-x-1/2 text-white lg:w-1/3 z-10">
          <h3 className="text-2xl tracking-wide font-fordBlack">
            Повече теглителна мощ
          </h3>
          <p className="mt-2 text-lg font-fordRegular">
            Хибридният Ford Kuga осигурява впечатляваща теглителна способност до
            2 100 кг¹. Вградените данни и карти изчисляват маршрути, подходящи
            за теглене, за да стигнеш до приключението без компромис.
          </p>
        </div>
      </div>
      {/* 3 columns text */}
      <div className="flex flex-col gap-4 p-4 my-4 lg:flex-row">
        <div className="flex-1 p-8 text-white bg-fordBlue rounded-2xl">
          <h3 className="text-3xl tracking-wide font-fordBold">
            Интелигентна навигация
          </h3>
          <p className="mt-4 hyphens-auto">
            С интелигентната навигация на Ford Kuga винаги си на най-добрия
            маршрут. Системата използва в реално време информация за трафика и
            пътните условия, за да ти предложи най-ефективния и безопасен път до
            целта.
          </p>
        </div>
        <div className="flex-1 p-8 text-white bg-fordBlue rounded-2xl">
          <h3 className="text-3xl tracking-wide font-fordBold">
            Асистент за мъртва точка
          </h3>
          <p className="mt-4 hyphens-auto">
            Системата за асистенция в мъртвата точка (Blind Spot Assist) на Ford
            Kuga следи зоните, които не виждаш в огледалата и ти помага да
            сменяш лентите по-безопасно.
          </p>
        </div>
        <div className="flex-1 p-8 text-white bg-fordBlue rounded-2xl">
          <h3 className="text-3xl tracking-wide font-fordBold">
            Асистент за проверка преди потегляне
          </h3>
          <p className="mt-4 hyphens-auto">
            Trailer Checklist на Ford Kuga винаги си сигурен, че всичко е в
            готовност преди потегляне. Системата ти напомня да провериш ключови
            елементи, свързани с ремаркето – като светлини, връзки, спирачки и
            налягане в гумите.
          </p>
        </div>
      </div>
      {/* Интелигентни технологии */}
      <h2 className="pt-16 pb-8 text-4xl tracking-wider text-center font-fordBlack text-fordBlue">
        Интелигентни технологии
      </h2>
      <div className="flex flex-col gap-4 px-4 py-8 lg:flex-row ">
        <div className="flex-1 overflow-hidden bg-gray-100 text-fordBlue rounded-2xl">
          <img
            src="/images/kuga4990/ford-kuga-green-front-view.jpg"
            alt=""
            className="mb-4"
          />
          <div className="p-8">
            <h3 className="text-3xl tracking-wide font-fordBold">
              Интелигентен круиз контрол
            </h3>
            <p className="mt-4 mb-8 hyphens-auto">
              Включва система за предказване на скоростта. Автоматично адаптира
              скоростта на вашия Kuga към пътните условия и промените в
              ограниченията на скоростта.
            </p>
          </div>
        </div>
        <div className="flex-1 overflow-hidden bg-gray-100 text-fordBlue rounded-2xl">
          <img
            src="/images/kuga4990/ford-kuga-light-detail.jpg"
            alt=""
            className="mb-4"
          />
          <div className="p-8">
            <h3 className="text-3xl tracking-wide font-fordBold">
              Адаптивни предни светлини
            </h3>
            <p className="mt-4 mb-8 hyphens-auto">
              Адаптивните предни светлини автоматично се приспособяват спрямо
              пътната обстановка, скоростта и завоите, за да осигурят оптимална
              видимост при всякакви условия.
            </p>
          </div>
        </div>
        <div className="flex-1 overflow-hidden bg-gray-100 text-fordBlue rounded-2xl">
          <img
            src="/images/kuga4990/ford-kuga-blue-front-view.jpg"
            alt=""
            className="mb-4"
          />
          <div className="p-8">
            <h3 className="text-3xl tracking-wide font-fordBold">
              Увереност при всяко пресичане
            </h3>
            <p className="mt-4 mb-8 hyphens-auto">
              Системата за помощ при пресичане (Intersection Assist) на новия
              Ford Kuga добавя още едно ниво на сигурност в натовареното градско
              движение. Тя следи пътната обстановка при приближаване към
              кръстовище и автоматично спира автомобила, ако засече потенциален
              сблъсък с пресичащи превозни средства.
            </p>
          </div>
        </div>
      </div>
      {/* Video 2 */}
      <div className="w-full">
        <video
          src="/images/kuga4990/ford-kuga-desertislandblue-walkAround.mp4"
          autoPlay
          muted
          loop
          playsInline
          className="block w-full h-auto"
        />
      </div>

      <section className="flex flex-col items-center px-4 py-12 lg:justify-center lg:p-16 lg:flex-row bg-gray-50">
        <a href="https://sale.ford.bg/?model=Kuga">
          <button className="px-12 py-2 mx-8 text-white border rounded-full border-fordLight bg-fordLight hover:bg-fordBlue hover:text-white">
            Виж налични автомобили
          </button>
        </a>
      </section>

      <motion.section
        id="poiskayOferta"
        className="w-full xl:w-[1300px] mx-auto py-8"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.5, delay: 1.3 }}
      >
        {renderContactForm()}
      </motion.section>

      <p className="px-2 text-sm text-center text-gray-500">
        * Цената е валидна за автомобил Kuga Titanium, 1.5 EcoBoost 150 к.с.,
        6-степенна механична скоростна кутия, при 5-годишен лизинг.
      </p>
    </>
  );
}

export default Kuga4990campaign;
